<div
  class="offset"
  [ngStyle]="{
    '--overlay-left': overlayLeftPosition,
    '--overlay-right': overlayRightPosition,
    '--offset-right': overlayOffsetRight,
    '--offset-left': overlayOffsetLeft,
    '--overlay-y': overlayVertPosition,
    '--overlay-w': selectedOverlayImage?.width,
    '--overlay-h': selectedOverlayImage?.height,
    '--base-w': selectedBaseImage?.width,
    '--base-h': selectedBaseImage?.height
  }"
>
  <div class="wrapper">
    <div class="base">
      <digital-platform-inline-image
        [inlineImageOverride]="baseImage[0]"
        [width100percent]="true"
        [height100percent]="!isMobile"
        [autoHeight]="isMobile"
      ></digital-platform-inline-image>
    </div>
    <div *ngIf="!isMobile" class="overlay">
      <digital-platform-inline-image
        [inlineImageOverride]="overlayImage[0]"
        [borderColor]="overlayBorderColor"
        [borderWidth]="overlayBorderWidth"
        [width100percent]="true"
        [height100percent]="true"
      ></digital-platform-inline-image>
    </div>
  </div>
</div>
